import React from 'react';
import { db } from './Firebase';

const AddItem = () => {

    // adding item 
    function addNewItem(e) {
        e.preventDefault();

        const itemForm = document.getElementById('addForm');
        const photo = document.getElementById('photoID');
        const form = new FormData();
        form.append('image', photo.files[0]);

        // uploading to imgbb
        fetch('https://api.imgbb.com/1/upload?key=5159c527ffc84ce94be36652b3fa0c9f', 
        { method: 'POST', body: form })
        .then(res => res.json())
        .then(image => {       
            const itemData = {
                name: itemForm.name.value,
                price: itemForm.price.value,
                photo: image.data.url
            }

            db.collection('items').add(itemData)
            .then(data => {
                if(data) {
                    itemForm.reset();
                    document.getElementById('successItem').innerHTML = 'Item Added!';
                }
            })
        })
    }

    return (
        <div className="col-md-6 mb-5">
            <article className="shadow px-3 py-4 p-md-5">
                <h4 className="title mb-4"><b>Add New Item</b></h4>
                <form id="addForm" onSubmit={addNewItem}>
                    <input type="text" className="form-control my-2" name="name" placeholder="Item Name" required />
                    <input type="number" min="0" className="form-control my-2" name="price" placeholder="Item Price" required />
                    <input id="photoID" type="file" className="my-2 mb-4" name="photo" required />
                    <input type="submit" value="Add item" className="text-white btn btn-one px-5" />
                </form>
                <p id="successItem" className="text-center my-3 text-success"></p>
            </article>
        </div>
    );
};

export default AddItem;